// 共通関数
// 配列空チェック
export const isEmptyArray = (array) => {
    return !Array.isArray(array) || !array.length;
};
export const randomString = (length) => {
    const source = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += source[Math.floor(Math.random() * source.length)];
    }
    return result;
};
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const replaceHalfWidthNumber = (s) => {
    // 全角数字の文字コードから65248個前が半角数字の文字コードとなっているので、65248引く
    const result = s.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248));
    return result;
};
// 小数点第二位以下を切り捨てる
export const floorOver2DecimalPoint = (s) => {
    const matchResult = s.match(/\../);
    if (!matchResult)
        return s;
    return s.replace(/\..*/, matchResult[0]);
};
// 桁数の丸め込み
export const floorOverDigits = (s, digits) => {
    const prefix = s.replace(/\..*/, '');
    if (prefix.length > digits) {
        s = s.replace(prefix, prefix.slice(0, digits));
    }
    return s;
};
